var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.multiple)?_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.clicktr.apply(null, arguments)}}},[(_vm.$parent.multiple)?_c('vs-checkbox',{attrs:{"checked":_vm.isSelected,"size":"small"},on:{"click":function($event){$event.stopPropagation();},"change":_vm.handleCheckbox}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }